import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  Button,
  ButtonBase,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import { PictureAsPdf } from "@mui/icons-material";
import { connect } from "react-redux";
import { openHasilLab } from "../../../redux/actions/history";
type Props = {
  tanggal: string;
  items: any;
  title: string;
  link: string;
  actOpenHasilLab: (link: string) => void;
  isReady: boolean;
};

const AccordionLabs = ({
  tanggal,
  items,
  title,
  link,
  actOpenHasilLab,
  isReady,
}: Props) => {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Accordion
      expanded={expanded === "panel1"}
      onChange={handleChange("panel1")}
      //   variant="outlined"
      elevation={0}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box>
          <Typography component="span" sx={{ display: "block" }}>
            {tanggal}
          </Typography>
          <Typography
            component="span"
            sx={{ color: "text.secondary", alignSelf: "center" }}
          >
            {items[0]?.product_name}
            {items.length - 1 > 0 && ` +${items.length - 1} lainnya`}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            maxHeight: "200px",
            overflowY: "scroll",
          }}
        >
          <Table>
            <TableBody>
              <TableRow
                // key={row.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  <ButtonBase
                    sx={{
                      borderBottom: "2px solid #FF0000",
                      paddingBottom: "4px",
                    }}
                    disabled={!isReady}
                    onClick={() => isReady && actOpenHasilLab(link)}
                  >
                    <PictureAsPdf fontSize="small" />
                    <Typography variant="body2" marginLeft="2px">
                      {isReady ? "Lihat Hasil" : "dalam proses"}
                    </Typography>
                  </ButtonBase>
                </TableCell>
              </TableRow>
              {items.map((item: any) => (
                <TableRow
                  // key={row.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {item.product_name}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
const mapStateToProps = (state: any) => {
  return {
    // stateHistoryLab: state.history.laboratorium,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    actOpenHasilLab: (link: any) => dispatch(openHasilLab(link)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccordionLabs);
